import find from 'lodash/find'
import { useUserStore } from '@/store/userStore'

export default function ({ store, redirect }) {
  const userStore = useUserStore()

  if (
    userStore.loggedIn &&
    !isSuperadmin(store.state.users.user) &&
    !isVisualizer(store.state.users.user) &&
    !isDemoAdmin(store.state.users.user)
  ) {
    return redirect('/forbidden')
  }
}

// Vistas abiertas solo para 'superadmin'
function isSuperadmin(user) {
  return user && user.role && user.role === 'superadmin'
}

function isDemoAdmin(user) {
  return (
    user &&
    user.role &&
    user.role === 'admin' &&
    process.env.FB_PROJECT_ID === 'demosburg-dev'
  )
}

function isVisualizer(user) {
  let isAdmin = false
  if (user.auxRole && user.auxRole === 'visualizer') {
    // If user isn't superadmin validate auxRole and module in availableModules
    const hasModule = find(user.availableModules, (o) => {
      return o.module === 'dashboard'
    })
    isAdmin = !!hasModule
  }
  return isAdmin
}
